import {Component, Inject, OnInit} from '@angular/core';
import {Select} from "@ngxs/store";
import {Observable} from "rxjs/internal/Observable";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {filter, map, reduce, startWith, switchMap} from "rxjs/operators";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UniversityField, WidgetFilter} from "../../core/models";
import {from} from "rxjs/index";
import {CoreService} from "../../core/services/core.service";
import {IndicatorChangedEvent} from "../indicator-select/indicator-select.component";

@Component({
  selector: 'app-filter-param-dialog',
  templateUrl: './filter-param-dialog.component.html',
  styleUrls: ['./filter-param-dialog.component.scss']
})
export class FilterParamDialogComponent implements OnInit {

  buttonLabel: string = 'Добавить';
  form: FormGroup;
  vals;
  @Select((s) => s.core.universityFields) universityFields$;
  universityFields = [];
  filteredValues: Observable<string[]>;

  ops = [
    {v: '=', name: '='},
    {v: '<', name: '⩽'},
    {v: '>', name: '⩾'},
    {v: '<<', name: 'a < x < b'},
  ];
  min: number;
  max: number;

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<FilterParamDialogComponent>,
              private coreService: CoreService,
              @Inject(MAT_DIALOG_DATA) private data: WidgetFilter) {

    this.prepareOptions();

    this.form = this.formBuilder.group({
      'type': [data ? this.universityFields.find(v => v.value == data.type) : null],
      'op':  [data ? data.op : '='],
      'vals': this.formBuilder.array([]),
      'university': [],
      'indicators': [],
      'method': [],
      'indicatorsFilter': [],
      'count': [],
    });
    this.vals = this.form.get('vals') as FormArray;

    if(data && data.op == '<<') {
      const vals = (data.val as string).split(';');
      this.vals.push(this.formBuilder.group({
        n: 'Минимальное значение',
        v: [vals[0], Validators.required]
      }));
      this.vals.push(this.formBuilder.group({
        n: 'Максимальное значение',
        v: [vals[1], Validators.required]
      }));
    } else {
      this.vals.push(this.formBuilder.group({
        n: 'Значение',
        v: [data ? data.val : '', Validators.required]
      }));
    }

    if(data) {
      this.buttonLabel = 'Сохранить';
      this.loadMinMax(data.type);
    }

    this.filteredValues = this.form.controls.type.valueChanges.pipe(
      startWith(''),
      map(value => this._filterValue(value))
    );


    this.form.controls.type.valueChanges.subscribe(
      v => {
        if(this.universityFields.includes(v)) {
          this.loadMinMax(v['value']);
        }
      });
  }

  ngOnInit(): void {
  }

  opSelected(evt: any, reset: boolean) {
    if(evt == '<<') {
      this.vals.controls[0].patchValue({
        n: 'Минимальное значение'
      });
      this.vals.push(this.formBuilder.group({
        n: 'Максимальное значение',
        v: ['', Validators.required]
      }));
    } else if(this.vals.length > 1) {
      this.vals.controls[0].patchValue({
        n: 'Значение'
      });
      this.vals.removeAt(1);
    }
  }

  complete() {
    const varLabel = 'Параметр';
    let payload;

    const typeLabel = typeof this.form.value.type === 'object' ? this.form.value.type.name : this.form.value.type;
    const op = this.ops.filter(x => x.v == this.form.value.op)[0];
    payload = {...this.form.value};
    payload.type = typeof payload.type === 'object' ? payload.type.value : payload.type;
    const val_min = payload.vals[0].v;

    if(payload.op == '<<') {
      const val_max = payload.vals[1].v;
      payload.label = `${val_min} < ${typeLabel} < ${val_max}`;
      payload.val = `${val_min};${val_max}`;
    } else {
      payload.label = `${typeLabel} ${payload.op} ${val_min}`;
      payload.val = val_min;
    }
    delete payload.vals;

    this.dialogRef.close({data: payload});
  }

  prepareOptions() {
    this.universityFields$
      .pipe(
        switchMap((v: Array<UniversityField>) => from(v)
          .pipe(
            filter( (v: UniversityField) => ['int', 'float', 'money'].includes(v.type)),
            reduce( (acc, v) => acc.concat(v), []),
          )
        )
      )
      .subscribe(v => this.universityFields = v);
  }

  private _filterValue(value: any): string[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.universityFields.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1);
    return [];
  }

  displayFn(field): string {
    return field && field.name ? field.name : '';
  }

  loadMinMax(field) {
    this.coreService.getUniversityFieldsMinMax(field).subscribe(
      response => {
        this.min = response['min'];
        this.max = response['max'];
      }
    );
  }

  indicatorChanged(event: IndicatorChangedEvent) {
    const value = this.universityFields.filter(option => event.value['indicator'] == option['value']);
    if(value.length) {
      this.form.patchValue({type: value[0]});
    }
  }

}
